import { BoundTextField } from "lib/@components/binding/bound-components"
import { convertToMinMaxNumber } from "lib/number"

/**
 * Recipient input for a `number` requested field. Numeric text field bound to `values.<field.id>`,
 * coercing the value through `convertToMinMaxNumber()` on the way out.
 *
 * @param {object} props
 * @param {{ id: string }} props.field
 */
export function NumberFieldInput({ field }) {
    return (
        <BoundTextField
            field={`values.${field.id}`}
            noLabel
            type="number"
            size="small"
            transformOut={convertToMinMaxNumber()}
        />
    )
}
